import { KeyboardArrowDown } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'

type ViewOlderMentionsProps = {
  showResolved: boolean
  refetchResolvedMentions: () => void
  refetchUnresolvedMentions: () => void
  translate: (key: string) => string
}

export const ViewOlderMentions = ({
  showResolved,
  refetchResolvedMentions,
  refetchUnresolvedMentions,
  translate,
}: ViewOlderMentionsProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      onClick={() => (showResolved ? refetchResolvedMentions() : refetchUnresolvedMentions())}
      sx={{ py: 2, cursor: 'pointer' }}
    >
      <Typography variant="Body12pxRegular" color="neutralLight.900">
        {translate('mentions.view-older')}
      </Typography>
      <KeyboardArrowDown sx={{ color: 'neutralLight.900', fontSize: 16 }} />
    </Stack>
  )
}
